
export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Our Story',
    headline: 'Locally Owned',
    description: `\tTwo Roosters began with roots deep in southern cuisine and the desire to continue the age-old tradition of kettle corn! With over a decade spent in the throes of the culinary world, Two Roosters was an escape from the coop of the restaurant life to focus on simple and delicious kettle corn. With the highest quality NonGMO ingredients, Two Roosters redefines a country fair favorite.
After getting the corn business popping, Two Roosters saw a need in the local market for high quality organic and small-batch roasted coffee. As a microroaster, every coffee bean is important and roasted to perfection — the Two Roosters way. 
Two Roosters is now proudly serving up the best damn NonGMO kettle corn and freshly roasted coffee in SWVA!`,
    imgStart: false,
    img: require('../../images/Two_Roosters_vector.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'kettle',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topline: 'Kettle Corn',
    headline: 'Simple Ingredients',
    description: `Mushroom corn kernels, canola oil, sugar and salt. Our ingredients are non-GMO and contain no animal products or preservatives. 
    \nOur product is popped “to order” which means it doesn’t sit around getting stale before we ship it. We use a high-volume, propane-powered Mann kettle, named Pappy. Kettle corn is better when the kettle has a name. That’s just science.`,
    imgStart: true,
    img: require('../../images/kettle-corn.jpeg'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: true
};

export const homeObjThree = {
    id: 'coffee',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Coffee',
    headline: 'Roasted by hand',
    description: `Our goal is simple: We want our coffee to be your go-to coffee - something you will want to drink every day. 
                    \nWe offer fresh, consistent, high-quality coffee at a reasonable price.`,
    imgStart: false,
    img: require('../../images/coffee.jpeg'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjFour = {
    id: 'bulk',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topline: 'Bulk Orders',
    headline: 'Special Occasions',
    description: `Personalized for events, gifts, retail, or whatever your shindig entails. 
 Photo features an example of product for a music venue.`,
    imgStart: true,
    img: require('../../images/bulk.jpeg'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: true
};

export const homeObjFive = {
    id: 'contact',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: '(540) 520-4210',
    headline: 'Contact',
    description: `Mailing Address: 
PO Box 4488 Roanoke, VA 24015
Email: info@thetworoosters.com`,
    imgStart: false,
    img: require('../../images/roanoke-star.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: false
};





